import {
  disableBodyScroll,
  enableBodyScroll as originEnableBodyScroll,
} from 'body-scroll-lock';

// Hack: bpk modal will aysnc set overflow:hidden on body
const enableBodyScroll = (targetElement: HTMLElement | Element) => {
  originEnableBodyScroll(targetElement);
  setTimeout(() => {
    document.body.style.overflow = '';
  });
};

export { disableBodyScroll, enableBodyScroll };
